import * as React from 'react';
import Notice, { Props as NoticeProps } from 'components/Notice';

import './styles/Toast.scss';

/**
 * ## Used to surface a [Notice](/internal/components/Notice) globally.
 *
 *
 * ```example
 * <Toast color="atlas" glyph="check">
 *   Toast
 * </Toast>
 * ```
 */

export type ToastOptions = Pick<NoticeProps, 'color' | 'glyph'>;
type Props = { children: React.ReactNode } & ToastOptions;

export const defaultToastOptions: { [k: string]: ToastOptions } = {
  success: { color: 'atlas', glyph: 'check' },
  error: { color: 'apple', glyph: 'close' },
};

const Toast: React.SFC<Props> = (props) => (
  <div className="Toast">
    <div className="Toast-contents">
      <Notice color={props.color} glyph={props.glyph}>
        {props.children}
      </Notice>
    </div>
  </div>
);

export default Toast;
